import React from "react";
import SchemaForm from "../components/SchemaForm";

const Generate = () => {
  return (
    <div style={{ background: "#F9FAFB", minHeight: "100vh" }}>
      <SchemaForm />
    </div>
  );
};

export default Generate;
